import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import PublicNavHeader from '../components/PublicNavHeader';
import Footer from '../components/Footer';

import {
  Bug,
  Lightning,
  Shield,
  Sparkle
} from '@phosphor-icons/react';
const Releases = () => {
  const releases = [
    {
      version: '2.1.0',
      date: 'Dec 2024',
      title: 'Partner Program Launch',
      items: [
        { type: 'feature', text: 'Partner application and directory' },
        { type: 'feature', text: 'Partner Pro subscription tier' },
        { type: 'improvement', text: 'Enhanced agent analytics' }
      ]
    },
    {
      version: '2.0.0',
      date: 'Nov 2024',
      title: 'Voice Agent Builder',
      items: [
        { type: 'feature', text: 'Voice agent configuration wizard' },
        { type: 'feature', text: 'Multi-LLM provider support' },
        { type: 'feature', text: 'Agent marketplace templates' },
        { type: 'security', text: 'Enhanced data encryption' }
      ]
    }
  ];

  const getTypeIcon = (type) => {
    switch (type) {
      case 'feature': return <Sparkle size={14} className="text-[#14F195]" />;
      case 'improvement': return <Lightning size={14} className="text-[#6366F1]" />;
      case 'fix': return <Bug size={14} className="text-[#F59E0B]" />;
      case 'security': return <Shield size={14} className="text-[#EC4899]" />;
      default: return <Sparkle size={14} className="text-[#718096]" />;
    }
  };

  return (
    <>
      <SEO title="Release Notes - Man & Machine" description="Stay up to date with the latest features and improvements." />
      <PublicNavHeader />
      
      <div className="min-h-screen bg-[#0a0a0f]">
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#6366F1]/10 via-transparent to-[#EC4899]/10" />
          
          <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-28">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center max-w-3xl mx-auto"
            >
              <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                Release Notes
              </h1>
              <p className="text-lg text-[#A0AEC0]">
                What's new in Man & Machine.
              </p>
            </motion.div>
          </div>
        </section>

        <section className="max-w-3xl mx-auto px-6 pb-20">
          <div className="space-y-8">
            {releases.map((release, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                className="glass rounded-2xl p-6"
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-2 py-1 bg-[#6366F1]/10 text-[#6366F1] text-sm font-mono rounded">v{release.version}</span>
                  <span className="text-[#718096] text-sm">{release.date}</span>
                </div>
                <h3 className="text-xl font-semibold text-white mb-4">{release.title}</h3>
                <ul className="space-y-2">
                  {release.items.map((item, j) => (
                    <li key={j} className="flex items-center gap-2 text-[#A0AEC0] text-sm">
                      {getTypeIcon(item.type)}
                      {item.text}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default Releases;